import React, { Component } from 'react';
import './index.scss';
// import logo from "/assets/images/logo.svg";
// import influx_logo from "../../assets/images/influx_logo.svg";
import { ReactComponent as ClockIcon } from './clock.svg';
import * as API from '../../configuration/apiconfig';
import { filterPackImageBasedOnImageCode } from '../../utils/FilterImages';
import { formatCurrentTime } from '../../utils/DateTimeFormat';
import queryString from 'query-string';
import { showAlert } from '../../components/showAlert';
import Loader from '../../pages/loader';
var setTime;

class index extends Component {
  constructor(props) {
    const parsedQueryString = queryString.parse(window.location.search);
    super(props);
    this.state = {
      currentDate: new Date(),
      month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      month: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      splashScreenImages: [],
      cinemaId: parsedQueryString.cinemaid != null ? parsedQueryString.cinemaid : null,
      allCinemas: [],
      selectLocation: {},
      loader: false,
      loader: false,
    };
  }

  componentDidMount() {
    var self = this;
    setTime = setInterval(() => {
      if (self.state.currentDate != new Date()) {
        self.setState({
          currentDate: new Date(),
        });
      }
    }, 2000);
    if (window.constant.SPLASH_SCREEN_SOURCE.includes('https') || window.constant.SPLASH_SCREEN_SOURCE.includes('http')) {
      console.log(window.constant.SPLASH_SCREEN_SOURCE.split(',')[0]);
      if (window.constant.SPLASH_SCREEN_SOURCE.includes('https') || window.constant.SPLASH_SCREEN_SOURCE.includes('http')) {
        console.log(window.constant.SPLASH_SCREEN_SOURCE.split(',')[0]);
        this.setState({
          splashScreenImages: window.constant.SPLASH_SCREEN_SOURCE.split(','),
          splashScreenImages: window.constant.SPLASH_SCREEN_SOURCE.split(','),
        });
      } else {
        API.callEndpoint('GET', 'Bearer', '/cms/v2/packs/' + window.constant.SPLASH_SCREEN_SOURCE).then(response => {
          API.callEndpoint('GET', 'Bearer', '/cms/v2/packs/' + window.constant.SPLASH_SCREEN_SOURCE).then(response => {
            var splashScreenImages = filterPackImageBasedOnImageCode(response, window.constant.SPLASH_SCREEN_IMAGECODE);
            this.setState({ splashScreenImages });
          });
        });
      }
    }
    document.cookie = 'accessToken=;max-age=0';
    document.cookie = 'refreshToken=;max-age=0';
    document.cookie = 'firstname=;max-age=0';
    document.cookie = 'lastname=;max-age=0';
    document.cookie = 'email=;max-age=0';
    document.cookie = 'phonenumber=;max-age=0';
    document.cookie = 'guestphonenumber=;max-age=0';
    API.logoutUser();
    localStorage.removeItem('sesstionid');
    localStorage.removeItem('cinemaid');
    localStorage.removeItem('selectedmoviename');
    localStorage.removeItem('selectedSeats');
    if (localStorage.getItem('orderId') != null && localStorage.getItem('orderFlowCompleted') == null) {
      this.deleteOrder();
    } else {
      localStorage.removeItem('orderId');
    }
    localStorage.removeItem('cartData');
    localStorage.removeItem('sessionExpiredRedirectUrl');
    localStorage.removeItem('endTimeInSecs');
    localStorage.removeItem('BookingCountdown');
    localStorage.removeItem('orderFlowCompleted');
    localStorage.getItem('ageRestrictionValidation') != null && localStorage.removeItem('ageRestrictionValidation');
    const urlParams = new URLSearchParams(window.location.search);
    const getCinemaId = urlParams.get('cinemaid');
    // console.log(getCinemaId, 'getCinemaId');
    if (getCinemaId != null) {
      localStorage.setItem('cinemaid', getCinemaId);
    }
    this.getCinemas();
  }
  componentWillUnmount() {
    clearInterval(setTime);
  }

  deleteOrder = () => {
    var orderDetails = JSON.parse(localStorage.getItem('orderId'));
    localStorage.removeItem('orderId');
    if (orderDetails?.id) {
      API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
        .then(response => {
          console.log(response);
        })
        .catch(ex => {
          console.log(ex.error);
        });
    }
  };

  getCinemas = () => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/cinemas')
      .then(response => {
        this.setState(
          {
            allCinemas: response.data,
          },
          () => {
            if (this.state.cinemaId != null) {
              var getObj = this.state.allCinemas.find(x => x.id == this.state.cinemaId);
              console.log(getObj, 'getObj');
              if (getObj != undefined) {
                this.setState({
                  selectLocation: getObj,
                });
              }
            }
          }
        );
      })
      .catch(ex => {
        console.log(ex.error);
      });
  };

  fnbSectionDisable = () => {
    if (window.constant.FNB_SECTION_DISABLE == 'true') {
      this.setState(
        {
          loader: true,
        },
        () => {
          var getCinemaId = this.state.cinemaId;
          API.callEndpoint('POST', 'Bearer', '/cms/v2/fnb/section/disable', { cinemaid: getCinemaId })
            .then(response => {
              this.setState(
                {
                  loader: false,
                },
                () => {
                  console.log(response.data, 'Fnb disable response');
                  var getDisableResponse = response.data;
                  if (getDisableResponse && getDisableResponse.cinemaid == getCinemaId && getDisableResponse.disabled) {
                    showAlert({
                      html: `<p class="fnb-disabled-text">Food & Drink Orders<span>The Cinema is closed for Food & Drink Orders from this kiosk.</span></p>`,
                      iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
                      showCancelButton: false,
                      cancelButtonText: 'CANCEL',
                      showConfirmButton: true,
                      confirmButtonText: 'OK',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      iconClasses: 'borderless',
                      popupClasses: 'common-error-alert fnb-section-disabled',
                      onConfirm: () => {},
                      onCancel: () => {},
                    });
                  } else {
                    localStorage.setItem('orderType', 'fnb');
                    window.location.href = '/login';
                  }
                }
              );
            })
            .catch(error => {
              this.setState({
                loader: false,
              });
              console.log(error.error, 'Fnb disable error');
            });
        }
      );
    } else {
      localStorage.setItem('orderType', 'fnb');
      window.location.href = '/login';
    }
  };

  handleButtonClick = action => {
    switch (action) {
      case 'fnb':
        this.fnbSectionDisable();
        break;
      case 'ticketing':
        localStorage.setItem('orderType', 'ticketing');
        window.location.href = '/movies';
        break;
      case 'pickup-tickets':
        window.location.href = '/pickup-tickets';
        break;
      default:
        break;
    }
  };

  render() {
    var { currentDate, selectLocation } = this.state;
    let getCinemaNameToDisplay = '';

    if (window.constant.SPLASH_SCREEN_CINEMA_NAME_WITH_CITY_AND_STATE == 'true') {
      if (Object.keys(selectLocation).length > 0) {
        getCinemaNameToDisplay =
          selectLocation.name + (selectLocation.city.length > 0 ? ', ' + selectLocation.city[0] : '') + (selectLocation.states.length > 0 ? ', ' + selectLocation.states[0] : '');
      }
    } else {
      if (Object.keys(selectLocation).length > 0) {
        getCinemaNameToDisplay = selectLocation.name;
      }
    }
    return (
      <>
        <Loader loader={this.state.loader} />
        <section className="splash-container" style={{ backgroundImage: "url('/assets/images/splash-bg.webp')" }}>
          <div className="top-sec">
            <div className="timer-sec">
              <ClockIcon className="icon" />
              <div className="text-center">
                <h3>{formatCurrentTime(currentDate)}</h3>
                <p>
                  {this.state.days[currentDate.getDay()]}, {this.state.month[currentDate.getMonth()]} {currentDate.getDate()}
                </p>
                {Object.keys(selectLocation).length > 0 ? <p className="location">{getCinemaNameToDisplay}</p> : <></>}
              </div>
            </div>
          </div>

          <div className="welcome-blk">
            <h1>
              Welcome <span>Movie Lover</span>
            </h1>
          </div>
          <div id="buttonsContainer">
            <div>
              {window.constant.SPLASH_BUTTONS.map(
                btn =>
                  btn.isVisible && (
                    <button key={btn.id} type="button" className="btn btn-primary" id={btn.id} onClick={() => this.handleButtonClick(btn.action)} dangerouslySetInnerHTML={{ __html: btn.label }} />
                  )
              )}
            </div>
          </div>

          <div className="btm-wrap">
            <div className="logo-sec">
              <a href="javascript:;">
                <img src={'/assets/images/logo.svg'} />
              </a>
            </div>

            <div className="poweredByInflux">
              <p>Powered by</p>
              <img src={'/assets/images/influx_logo.svg'} className="influxLogo" />
            </div>
          </div>
        </section>
      </>
    );
  }
}
export default index;
